import React from "react";
import { Card, Row, Col, Skeleton } from "antd";
import "./style.scss";

const DashboardCardsSkeleton = ({ count = 3 }) => {
  return (
      <div className="row g-2">
        <div className="col-md-6 row-gutter">
          <div className="card-body">
            <div className="vstack gap-5">
              {Array.from({ length: count }).map((_, idx) => (
                <Card key={idx} bordered={false} className="bg-transparent">
                  <Row gutter={[16, 16]}>
                    <Col md={5} sm={10} xs={10}>
                      <Skeleton.Image active />
                    </Col>
                    <Col md={18} sm={14} xs={14}>
                      <Skeleton active>
                        <Card.Meta
                          title={
                            <Skeleton.Input
                              style={{ width: 200 }}
                              active
                              size="small"
                            />
                          }
                          description={
                            <>
                              <Skeleton.Button
                                style={{ width: 100 }}
                                active
                                size="small"
                              />
                              <div style={{ marginTop: 10 }}>
                                <Skeleton.Input
                                  style={{ width: 150 }}
                                  active
                                  size="small"
                                />
                                {/* <Skeleton.Input
                                  style={{ width: 100 }}
                                  active
                                  size="small"
                                /> */}
                              </div>
                            </>
                          }
                        />
                        <div style={{ marginTop: 10 }}>
                          <Skeleton.Button style={{ width: 180 }} active />
                          <Skeleton.Button
                            style={{ width: 120,  marginTop: 10  }}
                            active
                          />
                        </div>
                      </Skeleton>
                    </Col>
                  </Row>
                </Card>
              ))}
            </div>
          </div>
        </div>
        <div className="col-md-6 row-gutter">
          <div className="card-body">
            <div className="vstack gap-5">
              {Array.from({ length: count }).map((_, idx) => (
                <Card key={idx} bordered={false} className="bg-transparent">
                  <Row gutter={[16, 16]}>
                    <Col md={5} sm={10} xs={10}>
                      <Skeleton.Image active />
                    </Col>
                    <Col  md={18} sm={14} xs={14}>
                      <Skeleton active>
                        <Card.Meta
                          title={
                            <Skeleton.Input
                              style={{ width: 200 }}
                              active
                              size="small"
                            />
                          }
                          description={
                            <>
                              <Skeleton.Button
                                style={{ width: 100 }}
                                active
                                size="small"
                              />
                              <div style={{ marginTop: 10 }}>
                                <Skeleton.Input
                                  style={{ width: 150 }}
                                  active
                                  size="small"
                                />
                                {/* <Skeleton.Input
                                  style={{ width: 100 }}
                                  active
                                  size="small"
                                /> */}
                              </div>
                            </>
                          }
                        />
                        <div style={{ marginTop: 10 }}>
                          <Skeleton.Button style={{ width: 180 }} active />
                          <Skeleton.Button
                            style={{ width: 120,  marginTop: 10  }}
                            active
                          />
                        </div>
                      </Skeleton>
                    </Col>
                  </Row>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
};

export default DashboardCardsSkeleton;
